//@flow
import withHandledHistoryLogPropName from "./withHandledHistoryLogPropName";
import HistoryLogPropNameValue from "./HistoryLogPropNameValue";

const ConnectedHistoryLogPropNameValue = withHandledHistoryLogPropName(HistoryLogPropNameValue);
export default ConnectedHistoryLogPropNameValue;